import partial from 'lodash/partial'
import {segment} from './helpers'

export const receivedNearestShowroomsResponse = partial(segment, 'Nearest Showrooms Received')
